import * as React from 'react';
import { Redirect } from 'react-router-dom';

import { Heading } from '../../components/Heading';
import { FullMatchFragment, useMatchVotesQuery } from '../../generated/graphql';
import { ButtonLink } from '../../components/Button';
import { paths } from '../../paths';
import { isNil } from '../../utils/isNil';
import { LoadingSpinner } from '../../components/LoadingContainer';
import { isTeamMember } from '../Match/matchUtils';
import { ViewVotes } from './ViewVotes';

interface Props {
  match: FullMatchFragment;
}

export const ReadVotes: React.FC<Props> = ({ match }) => {
  const [votesRes] = useMatchVotesQuery({ variables: { matchId: match.id } });

  if (
    match.voteCount === 0 ||
    match.votingStatus !== 'CLOSED' ||
    !isTeamMember(match.team)
  ) {
    return <Redirect to={paths.match.home(match.id)} />;
  }

  const votes = votesRes.data?.match?.voteResult?.votes;

  return (
    <div className="space-y-6">
      <Heading className="text-2xl">Match Votes</Heading>
      {votesRes.fetching ? (
        <LoadingSpinner className="border-primary-500 mx-auto" />
      ) : null}

      {!isNil(votes) ? <ViewVotes votes={votes} /> : null}
      <ButtonLink to={paths.match.votes.summary(match.id)}>
        View results
      </ButtonLink>
      <ButtonLink to={paths.match.home(match.id)} kind="plain">
        Back to match
      </ButtonLink>
    </div>
  );
};
